export default {
  consultarProtocolo: state => state.redeSIM.consultarProtocolo
};
